<div class="panel panel-default">
  <div class="panel-heading">
    <h3 class="panel-title">
      Cancellation Statistics
    </h3>
    <i class="fa fa-info circle-icon"
      title="Clicking on legend entries toggles them from the graph. Empty graphs signify no data available."></i>
  </div>
  <div class="panel-body" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
    <div class="mt-4 mx-auto">
      <ch-select-picker [items]="subscriptionTypes" (change)="subscriptionTypeChanged($event)"
        [value]="subscriptionType"></ch-select-picker>
    </div>

    <!-- Charts Container -->
    <div style="display: flex; flex-direction: row; width: 100%; margin-top: 20px; gap: 20px;">
      <!-- Historical Cancellations Chart -->
      <div style="flex: 1;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <ch-select-picker [items]="cancellationPeriods" (change)="cancellationPeriodChanged($event)"
            [value]="cancellationPeriod"></ch-select-picker>
          <h4 style="margin: 0; flex: 1; text-align: center;">Historical Cancellations</h4>
          <div style="width: 120px;"></div> <!-- Spacer to balance the layout -->
        </div>
        <canvas id="historicalCancellationsChartCanvas">{{ historicalCancellationsChart }}</canvas>
      </div>

      <!-- Upcoming Cancellations Chart -->
      <div style="flex: 1;">
        <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 10px;">
          <h4 style="margin: 0;">Upcoming Cancellations</h4>
        </div>
        <canvas id="upcomingCancellationsChartCanvas">{{ upcomingCancellationsChart }}</canvas>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/exit-survey/exit-survey-list/cancellations-statistics/cancellations-statistics.component.html